const u = up.util;
up.Change.CloseLayer = class CloseLayer extends up.Change {
    constructor(options) {
        var _a, _b;
        super(options);
        this._verb = options.verb;
        this.layer = up.layer.get(options);
        this._origin = options.origin;
        this._value = options.value;
        this._preventable = (_a = options.preventable) !== null && _a !== void 0 ? _a : true;
        this._response = options.response;
        this._history = (_b = options.history) !== null && _b !== void 0 ? _b : true;
    }
    execute() {
        this.layer.assertAlive();
        up.browser.assertConfirmed(this.options);
        if (this._emitCloseEvent().defaultPrevented && this._preventable) {
            throw new up.Aborted('Close event was prevented');
        }
        this._emitClosingEvent();
        up.fragment.abort({ reason: 'Layer is closing', layer: this.layer });
        this.layer.state = 'closing';
        const { parent } = this.layer;
        this.layer.peel();
        this._handleFocus(parent);
        this.layer.teardownHandlers();
        this.layer.destroyElements(this.options);
        this.layer.stack.remove(this.layer);
        if (this._history) {
            parent.restoreHistory();
        }
        this.layer.state = 'closed';
        this._emitClosedEvent(parent);
    }
    _emitCloseEvent() {
        let event = this.layer.emit(this._buildEvent(`up:layer:${this._verb}`), {
            callback: this.layer.callback(`on${u.upperCaseFirst(this._verb)}`),
            log: [`Will ${this._verb} ${this.layer} with value %o`, this._value]
        });
        this._value = event.value;
        return event;
    }
    _emitClosingEvent() {
        let event = this._buildEvent(`up:layer:${this._verb}ing`);
        this.layer.emit(event, { log: false });
    }
    _emitClosedEvent(formerParent) {
        const verbPast = `${this._verb}ed`;
        const verbPastUpperCaseFirst = u.upperCaseFirst(verbPast);
        return this.layer.emit(this._buildEvent(`up:layer:${verbPast}`), {
            baseLayer: formerParent,
            callback: this.layer.callback(`on${verbPastUpperCaseFirst}`),
            ensureBubbles: true,
            log: [`${verbPastUpperCaseFirst} ${this.layer} with value %o`, this._value]
        });
    }
    _buildEvent(name) {
        return up.event.build(name, {
            layer: this.layer,
            value: this._value,
            origin: this._origin,
            response: this._response,
        });
    }
    _handleFocus(formerParent) {
        var _a;
        let hadFocus = this.layer.hasFocus();
        this.layer.overlayFocus.teardown();
        (_a = formerParent.overlayFocus) === null || _a === void 0 ? void 0 : _a.moveToFront();
        if (hadFocus) {
            let newFocusElement = this.layer.origin || formerParent.element;
            up.focus(newFocusElement, { preventScroll: true });
        }
    }
};
